import React from "react";
import "./NotFound.css";

export default () =>
  <div className="NotFound">
    <h3>Sorry, page not found!</h3>
  </div>;



// WEBPACK FOOTER //
// ./src/containers/NotFound.js